import { Route } from '@/app/router'
import TasksEnabled from '@/middleware/TasksEnabled'
import QuantityDisabled from '@/middleware/QuantityDisabled'

const Task = () => import('./index.vue')

const TaskProps = ['page', 'perPage']

export default new Route('/tasks/:id', Task)
	.as('Dashboard:Task')
	.props(TaskProps)
	.permissions(['TASK_FLOW_ENABLED', 'VIEW_TASK', 'PARTS_QUANTITY_DISABLED'])
	.middlewares([TasksEnabled, QuantityDisabled])
